import { useEffect, useRef, useState } from 'react';
import axios from 'axios';

export default function AdminMeetingSlot({ roundId, docenten, onClose, onSaved }) {
  const [date,setDate]=useState('');
  const [start,setStart]=useState('');
  const [end,setEnd]=useState('');
  const [docentId,setDocentId]=useState(docenten.length===1 ? docenten[0].docent_id : '');
  const [note,setNote]=useState('');
  const [saving,setSaving]=useState(false);
  const [error,setError]=useState('');
  const closeRef=useRef(null);
  const today=new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Amsterdam'}).format(new Date());
  useEffect(()=>{
    const previous=document.activeElement,overflow=document.body.style.overflow;
    document.body.style.overflow='hidden';closeRef.current?.focus();
    return ()=>{document.body.style.overflow=overflow;previous?.focus();};
  },[]);
  const save=async event=>{
    event.preventDefault();if(saving)return;setError('');
    if(end<=start){setError('Eindtijd moet later zijn dan begintijd.');return;}
    setSaving(true);
    try{
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/meeting-round/admin/${roundId}/slots`,{
        date,start_time:start,end_time:end,docent_id:docentId||null,note
      },{headers:{Authorization:`Bearer ${sessionStorage.getItem('jwtToken')}`}});
      await onSaved();onClose();
    }catch(err){setError(err.response?.data?.error||'Tijdslot toevoegen mislukt. Probeer opnieuw.');}
    finally{setSaving(false);}
  };
  return <div className="modal show d-block" role="dialog" aria-modal="true" aria-labelledby="admin-slot-title" style={{background:'rgba(0,0,0,.45)',zIndex:10000}}
    onKeyDown={event=>{
      if(event.key==='Escape'&&!saving){event.preventDefault();onClose();}
      if(event.key==='Tab'){
        const fields=[...event.currentTarget.querySelectorAll('button:not(:disabled),input:not(:disabled),select:not(:disabled)')];
        if(!fields.length){event.preventDefault();return;}
        if(event.shiftKey&&document.activeElement===fields[0]){event.preventDefault();fields[fields.length-1].focus();}
        if(!event.shiftKey&&document.activeElement===fields[fields.length-1]){event.preventDefault();fields[0].focus();}
      }
    }}>
    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable"><div className="modal-content">
      <div className="modal-header"><h3 className="modal-title h5" id="admin-slot-title">Tijdslot toevoegen</h3><button ref={closeRef} type="button" className="btn-close" aria-label="Sluiten" disabled={saving} onClick={onClose}/></div>
      <form onSubmit={save} style={{minWidth:0,overflowY:'auto'}}>
        <div className="modal-body">
          <p className="small text-muted">Voeg een vrij tijdslot toe aan deze ronde. Datum en tijden zijn in Nederlandse tijd.</p>
          {error&&<div className="alert alert-danger" role="alert">{error}</div>}
          <label htmlFor="admin-slot-date" className="form-label">Datum</label>
          <input id="admin-slot-date" className="form-control mb-3" type="date" min={today} value={date} onChange={e=>setDate(e.target.value)} disabled={saving} required/>
          <div className="row g-3 mb-3">
            <div className="col-6"><label htmlFor="admin-slot-start" className="form-label">Begintijd</label><input id="admin-slot-start" type="time" className="form-control" value={start} onChange={e=>setStart(e.target.value)} disabled={saving} required/></div>
            <div className="col-6"><label htmlFor="admin-slot-end" className="form-label">Eindtijd</label><input id="admin-slot-end" type="time" className="form-control" value={end} onChange={e=>setEnd(e.target.value)} disabled={saving} required/></div>
          </div>
          {docenten.length>0&&<><label htmlFor="admin-slot-teacher" className="form-label">Docent</label><select id="admin-slot-teacher" className="form-select mb-3" value={docentId} onChange={e=>setDocentId(e.target.value)} disabled={saving} required>
            <option value="">Kies een docent</option>{docenten.map(docent=><option key={docent.docent_id} value={docent.docent_id}>{docent.docent_name}</option>)}
          </select></>}
          <label htmlFor="admin-slot-note" className="form-label">Opmerking <span className="text-muted">(optioneel)</span></label>
          <input id="admin-slot-note" className="form-control" value={note} onChange={e=>setNote(e.target.value)} maxLength={500} disabled={saving}/>
        </div>
        <div className="modal-footer"><button type="button" className="btn btn-secondary" disabled={saving} onClick={onClose}>Annuleren</button><button className="btn btn-success" disabled={saving||!date||!start||!end||(docenten.length>0&&!docentId)}>{saving?'Opslaan...':'Tijdslot opslaan'}</button></div>
      </form>
    </div></div>
  </div>;
}
